module.exports = __webpack_public_path__ + "static/media/KMH_5024.e36a31ff.jpg";